import { observer } from 'mobx-react';
import React, { Component } from 'react';
import './client.css'
import { ClientProjects } from './ClientProjects';
import { ClientSales } from './ClientSales';
import { ClientInvoices } from './ClientInvoices';
import { ClientInvoiceReport } from './ClientInvoiceReport';
import LoyaltyLevelSelect from './LoayltyLevelSelect';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import AuthStore from '../../Auth/AuthStore'
import AccountWageRates from '../Projects/AccountWageRates';


const ClientCard = observer(class ClientCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: {
                percent: 0,
                isArchive: false
            }
        };

        this.loadClient = this.loadClient.bind(this);
        this.handleIsArchiveChange = this.handleIsArchiveChange.bind(this);
    }

    componentDidMount() {
        var url = new URL(document.location.href);
        var id = url.searchParams.get("id");
        if (id) {
            this.loadClient(id);
        }
    }

    loadClient(id) {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Account/load?id=' + id, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ client: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleIsArchiveChange(evt) {
        var client = this.state.client;
        client.isArchive = evt.target.checked;
        this.setState({ client: client });

        var scope = this;
        //scope.setState({ isSaving: true });
        var token = localStorage.getItem("token");
        fetch('api/Account/UpdateArchiveValue', {
            method: 'POST',
            body: JSON.stringify({ value: evt.target.checked, accountId: this.state.client.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                //scope.setState({ isAccountSaving: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    //scope.setState({ isChanged: false, id: result.id, isSaving: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div style={{ overflowY: "auto" } }>
                <h2>{this.state.client.name}</h2>
                <br/>
                <h3>Всего потрачено на работы КВ и РБР(примерно): {this.state.client.percent.toFixed(2)}%</h3>
                <br />
                <LoyaltyLevelSelect accountId={this.state.client.id} name={this.state.client.loyaltyLevel} />
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.client.isArchive}
                                onChange={this.handleIsArchiveChange}
                                value="isArchive"
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }}
                            />}
                        label="Архивный"
                    />
                </div>
                <div className="clearfix">
                    <div className="client-half-block">
                        <ClientInvoiceReport accountId={this.state.client.id} />
                    </div>
                    <div className="client-half-block">
                        <ClientProjects accountId={this.state.client.id} />
                    </div>
                </div>
                <div className="clearfix">
                        <div className="client-half-block">
                        <ClientSales accountId={this.state.client.id} />
                    </div>
                    <div className="client-half-block">
                        <ClientInvoices accountId={this.state.client.id} />
                    </div>
                </div>

                <div className="clearfix">
                    <div className="client-half-block">
                        <AccountWageRates accountId={this.state.client.id} />
                    </div>
                    <div className="client-half-block">
                    </div>
                </div>

            </div>
        );
    }
});

export default ClientCard;